/** "first_name" / "firstName" -> "First Name" */
export function humanize(variable: string): string {
    return variable
        .replace(/_+/g, ' ')
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export function placeholder(variable: string): string {
    return `{{${variable}}}`;
}

export function sampleValue(variable: string): string {
    return `Sample ${humanize(variable)}`;
}

export interface MergeTag {
    name: string;
    value: string;
    sample: string;
}

/** Unlayer `mergeTags` option: exactly the allowed variables, inserted as {{name}}. */
export function buildMergeTags(variables: string[]): Record<string, MergeTag> {
    const tags: Record<string, MergeTag> = {};
    (variables || []).forEach(variable => {
        tags[variable] = { name: humanize(variable), value: placeholder(variable), sample: sampleValue(variable) };
    });
    return tags;
}

/** Replaces every {{name}} with its sample value, for the preview only. */
export function fillSamples(content: string, variables: string[]): string {
    const allowed = new Set(variables || []);
    return (content || '').replace(/\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g, (match, name) =>
        allowed.has(name) ? sampleValue(name) : match
    );
}
